// src/services/RealTime/realtimeCommon.ts

import { makeLogger as makeRealtimeLogger } from '@/helpers'

export function normalizeScopes (scopes) {
  return (scopes || [])
    .map((s) => String(s || '').trim())
    .filter((s) => Boolean(s))
}

export function scopesKey (scopes) {
  return normalizeScopes(scopes).sort().join('|')
}

export function diffScopes (prev, next) {
  const prevSet = new Set(normalizeScopes(prev))
  const nextSet = new Set(normalizeScopes(next))

  const added: any[] = []
  const removed: any[] = []

  for (const s of nextSet) {
    if (!prevSet.has(s)) {
      added.push(s)
    }
  }

  for (const s of prevSet) {
    if (!nextSet.has(s)) {
      removed.push(s)
    }
  }

  return { added, removed }
}

export function unwrapWsPayload (msg) {
  if (msg == null) {
    return null
  }

  let data = msg

  // WSClient per-scope handlers receive an envelope: { topic, scope, raw, data }
  if (msg && typeof msg === 'object') {
    if (msg.data && typeof msg.data === 'object') {
      data = msg.data
    } else if (typeof msg.raw === 'string') {
      data = msg.raw
    }
  }

  if (typeof data === 'string') {
    try {
      data = JSON.parse(data)
    } catch {
      return null
    }
  }

  if (!data || typeof data !== 'object') {
    return null
  }

  return data
}

export { makeRealtimeLogger }
